
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'device-back': `Regresa a la Lista de Dispositivos`,
'friday': `Viernes`,
'home-carousel-prefix': `Página`,
'home-link': `Inicio`,
'info-and-hours-back': `Atrás`,
'monday': `Lunes`,
's344c7633610bf8b0': `Volver arriba`,
's355b21b89ce5d9c5': `Detalles`,
's9eff639fb8a1be0a': `segundos`,
'saturday': `Sábado`,
'sc16e00a7a8b2fde2': `Atrás`,
'sdb7d426d5522303c': `Servicios Walgreens Health Corner`,
'services-modal-close': `Cerrar`,
'sunday': `Domingo`,
'thursday': `Jueves`,
'tuesday': `Martes`,
'walgreens-logo': `Logotipo de Walgreens`,
'wednesday': `Miércoles`,
    };
  